
    const data = {"name":"src/core/icons/chart-bar","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M22 21H2V3h2v16h2v-9h4v9h2V6h4v13h2v-5h4v7Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            